import { render } from "./UpdateSingle.vue?vue&type=template&id=404e1eee&scoped=true"
import script from "./UpdateSingle.vue?vue&type=script&lang=js"
export * from "./UpdateSingle.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404e1eee"]])

export default __exports__